// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1F2hW","signatureBlock":"Footer_signatureBlock__2KGBb","signature":"Footer_signature__2aUM6"};